import { SelectOption } from "atoms/forms/select";
import UserBookmarkSortOption from "models/enumerations/sorting/user-bookmarks/user-bookmark-sort-option";
import SelectFormField from "molecules/form-fields/select-form-field";
import React from "react";
import { SortByValueToNameMap } from "utilities/bookmark-utils";
import { t } from "utilities/localization-utils";
interface SortByProps {
    sort?: UserBookmarkSortOption;
    onChange: (option: SelectOption | undefined) => void;
    showBookOrder?: boolean;
}

const SortBy = ({ sort, onChange, showBookOrder }: SortByProps) => {
    const options: SelectOption[] = [
        {
            data: UserBookmarkSortOption.CreatedOnAscending,
            value: UserBookmarkSortOption.CreatedOnAscending.toString(),
            label: t(
                SortByValueToNameMap[UserBookmarkSortOption.CreatedOnAscending]
            ),
        },
        {
            data: UserBookmarkSortOption.CreatedOnDescending,
            value: UserBookmarkSortOption.CreatedOnDescending.toString(),
            label: t(
                SortByValueToNameMap[UserBookmarkSortOption.CreatedOnDescending]
            ),
        },
        ...[
            ...(showBookOrder
                ? [
                      {
                          data: UserBookmarkSortOption.BookOrder,
                          value: UserBookmarkSortOption.BookOrder.toString(),
                          label: t(
                              SortByValueToNameMap[
                                  UserBookmarkSortOption.BookOrder
                              ]
                          ),
                      },
                  ]
                : []),
        ],
    ];

    const handleOnChange = (newVal: SelectOption | undefined) => {
        onChange(newVal?.data);
    };
    return (
        <>
            <SelectFormField
                ariaLabelOnly
                label={t("sortBy")}
                value={sort?.toString()}
                onChange={handleOnChange}
                options={options}
            />
        </>
    );
};

export default SortBy;
